export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5" data-testid="logo">
    <img
      src="/images/logo.png"
      alt="XMOVE Italia — xmoveitalia.com — noleggio a lungo termine"
      className="h-10 w-10 object-contain"
      data-testid="logo-image"
    />
    <span className="flex flex-col justify-center leading-none">
      <span className={`font-display text-[22px] font-bold tracking-tight ${dark ? "text-white" : "text-xmove-ink"}`}>
        XMOVE
        <span className="text-xmove-orange">.</span>
      </span>
      <span className="mt-1 text-[10px] font-bold tracking-[0.14em] text-xmove-orange" data-testid="logo-domain">
        xmoveitalia.com
      </span>
    </span>
  </span>
);
